export const serverState = {
    
};